var map = {
	"./calcs/2018/processed/policyOptions.json": 1198,
	"./calcs/2019_01/processed/policyOptions.json": 1199,
	"./calcs/2019_06/processed/policyOptions.json": 1200,
	"./calcs/2019_08/processed/policyOptions.json": 1201,
	"./calcs/2019_08_tax/processed/policyOptions.json": 1202,
	"./calcs/2020_01/processed/policyOptions.json": 1203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 627;